import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { CoordinatesExact } from '../../models/Coordinates';

const PipelineCenterline = ({ index, coordinatesArray, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude]),
      },
      properties: {
        width: 5,
        color: theme.palette.map.pipelineCenterline,
      },
    }),
    [coordinatesArray, theme.palette.map.pipelineCenterline]
  );

  const layerFeatures = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: visible ? [sourceData] : [],
    }),
    [visible, sourceData]
  );

  return (
    <GeoJSONLayer
      id={`pipelineCenterline${index}`}
      type="geojson"
      data={layerFeatures}
      lineLayout={{
        'line-join': 'round',
        'line-cap': 'round',
      }}
      linePaint={{
        'line-color': ['get', 'color'],
        'line-width': ['get', 'width'],
      }}
    />
  );
};

PipelineCenterline.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  visible: PropTypes.bool,
};

PipelineCenterline.defaultProps = {
  coordinatesArray: [],
  index: 0,
  visible: true,
};

export default React.memo(PipelineCenterline);
